/** @jsxImportSource ../../i18n */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Gavel } from 'lucide-react';
import api from '../../services/api';
import { Button } from '../ui';

// "Mettre en procès": opens a trial on a held line and goes to the hearing;
// a refusal (no panel, a run in progress, daily limit) shows next to it.
export const TrialLauncher = ({ symbol }) => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const open = async () => {
    setBusy(true);
    setError('');
    try {
      const res = await api.post('/trials', { symbol });
      navigate(`/proces/${res.data.run_id}`);
    } catch (err) {
      setBusy(false);
      setError(err?.response?.data?.error || 'Le tribunal est indisponible.');
    }
  };
  return (
    <span className="inline-flex flex-col items-start gap-1">
      <Button variant="secondary" size="sm" leadingIcon={Gavel} loading={busy} onClick={open}>Mettre en procès</Button>
      {error && <span role="alert" className="max-w-[16rem] text-xs text-loss-300">{error}</span>}
    </span>
  );
};

export default TrialLauncher;
